import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/twitter-seo-tips-2025.webp")